import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Menu.module.scss';

import { useSubscription } from '../../../features/subscription/SubscriptionProvider';

const Menu = ({ closeMenu }) => {
  const { isSubscribed, restorePurchases, isNativePlatform } = useSubscription();
  const [restoring, setRestoring] = useState(false);
  const [message, setMessage] = useState(null);

  // Blocks scroll on body component on mount and unblocks on unmount
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.removeProperty('overflow');
    };
  }, []);

  const handleRestore = async () => {
    setRestoring(true);
    setMessage(null);
    const result = await restorePurchases();
    setRestoring(false);

    if (result.success) {
      if (result.hasSubscription) {
        setMessage('Abonnement gjenopprettet!');
      } else {
        setMessage('Ingen tidligere kjøp funnet');
      }
    } else {
      setMessage('Kunne ikke gjenopprette. Prøv igjen.');
    }
  };

  return (
    <div className={styles.container}>
      <article className={styles.content}>
        <section className={styles.topButtons}>
          {isNativePlatform && !isSubscribed && (
            <button
              className={styles.logOutButton}
              onClick={handleRestore}
              disabled={restoring}
            >
              {restoring ? 'Gjenoppretter...' : 'Gjenopprett kjøp'}
            </button>
          )}
          <button onClick={closeMenu}>Lukk meny</button>
        </section>

        {message && (
          <p className={styles.message} style={{ textAlign: 'center', padding: '10px' }}>
            {message}
          </p>
        )}

        <ul className={styles.navList}>
          <li>
            {isSubscribed ? (
              <div>
                <span>Du har aktivt abonnement</span>
                {isNativePlatform && (
                  <a
                    href="https://apps.apple.com/account/subscriptions"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.manageSubscription}
                  >
                    Administrer abonnement
                  </a>
                )}
              </div>
            ) : (
              <Link to="/paywall" onClick={closeMenu} className={styles.subscriptionLink}>
                Få tilgang til alle oppskrifter ved å abonnere
              </Link>
            )}
          </li>
        </ul>

        <section className={`${styles.card} ${styles.feedback}`}>
          <section className={styles.icons}>
            <img
              src="/icons/thumb_down.svg"
              alt=""
              onLoad={(e) => (e.target.style.opacity = 1)}
            />
            <img
              src="/icons/thumb_up.svg"
              alt=""
              onLoad={(e) => (e.target.style.opacity = 1)}
            />
          </section>

          <p className={styles.heading}>Gi oss tilbakemeldinger!</p>
          <p className={styles.description}>
            Dersom det er noe du liker, eller Noe du ikke liker, så vil Iver &
            Evne gjerne høre fra deg. Kontakt oss på:
          </p>

          <a href="mailto:post@iverogevne.no" className={styles.emailLink}>
            {'post@iverogevne.no'}
          </a>
        </section>

        <section className={styles.socialMedia}>
          <a
            href="https://www.facebook.com/iverogevne"
            title="Iver og Evne på facebook"
          >
            <img src="/icons/fb_icon.svg" alt="" />
          </a>
          <a
            href="https://www.instagram.com/iverogevne"
            title="Iver og Evne på Instagram"
          >
            <img src="/icons/insta_icon.svg" alt="" />
          </a>
        </section>

        <section className={styles.legalLinks}>
          <a
            href="https://cheffihub.com/privacy-policy.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Personvern
          </a>
          <span className={styles.separator}>|</span>
          <a
            href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Vilkår
          </a>
        </section>
      </article>
    </div>
  );
};

export default Menu;
